import { ENTranslation } from 'presentations/assets/JSONAsset';

export const TRANSLATIONS_EN = ENTranslation;
